import SanityBlockContent from '@sanity/block-content-to-react';
import React from 'react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import { ButtonComponentStyles } from '../../utils/utils';
import Button from '../Button/button';
import { serializers } from '../../utils/blockMarks';
import clientConfig from '../../../client-config';

import './index.scss';

const Timeline = ({ deviceView: { IsMobile }, data }) => {
  const limitedData = 5;
  const [dataCount, setDataCount] = React.useState(limitedData);
  const [seeMore, setSeeMore] = React.useState(false);
  const tlData = IsMobile ? data.slice(0, dataCount) : data;
  const seeMoreData = () => {
    setSeeMore(true);
    setDataCount(data.length);
  };

  const hideData = () => {
    setSeeMore(false);
    setDataCount(limitedData);
  };

  return (
    <div>
      <div className="timeline-pattern">
        <h2 className="text-title">TurfMutt Timeline</h2>
      </div>
      <div className="timeline-wrapper">
        <div className="container">
          <ul className="timeline-list">
            {tlData.map(({ id, heading, image, paragraph }) => {
              return (
                <li key={Math.random().toString(36).substring(7)} id={id}>
                  <div className="timeline-content">
                    <div className="timeline-image">
                      <Img fluid={getFluidGatsbyImage(image, { maxWidth: 675 }, clientConfig.sanity)} alt=" " />
                    </div>
                    <div className="timeline-text">
                      <h3 className="timeline-title">{heading}</h3>
                      {typeof paragraph === 'string' ? (
                        <p className="timeline-description">{paragraph}</p>
                      ) : (
                        <SanityBlockContent blocks={paragraph} serializers={serializers} />
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
          {IsMobile ? (
            <div className="text-center">
              <Button
                title={!seeMore ? 'See More' : 'Hide'}
                buttonStyle={ButtonComponentStyles.OUTLINE}
                onClicked={!seeMore ? seeMoreData : hideData}
                showIcon
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className="timeline-pattern">
        <h2 className="text-title">Present</h2>
      </div>
    </div>
  );
};

export default Timeline;
